import { useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";

export default function ViewTiffinPlan() {
  const location = useLocation();
  const data = location.state.data;

  console.log("data", data);

  return (
    <div>
      <Layout>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-medium">View Plan</h2>
          </div>
          <div className="mt-10">
            <div className="flex my-6">
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Name</h6>
                <p className="mt-1">{data.name}</p>
              </div>
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Duration</h6>
                <p className="mt-1">{data.duration}</p>
              </div>
            </div>
            <hr />

            <div className="flex my-6">
              {/* <div className="w-1/2">
                <h6 className="text-sm font-medium">Quantity</h6>
                <p className="mt-1">{data.quantity}</p>
              </div> */}
              <div className="w-1/2">
                <h6 className="text-sm font-medium">Price</h6>
                <p className="mt-1">{data.price}</p>
              </div>
            </div>
           
          </div>
        </div>
      </Layout>
    </div>
  );
}
